var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40007 1.20002C3.08044 1.20002 1.20002 3.08044 1.20002 5.40007C1.20002 7.7197 3.08044 9.60012 5.40007 9.60012C7.7197 9.60012 9.60012 7.7197 9.60012 5.40007C9.60012 3.08044 7.7197 1.20002 5.40007 1.20002ZM0 5.40007C0 2.41769 2.41769 0 5.40007 0C8.38245 0 10.8001 2.41769 10.8001 5.40007C10.8001 8.38245 8.38245 10.8001 5.40007 10.8001C2.41769 10.8001 0 8.38245 0 5.40007Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36579 8.36617C8.6001 8.13185 8.98001 8.13185 9.21433 8.36617L11.8244 10.9762C12.0587 11.2105 12.0587 11.5904 11.8244 11.8247C11.59 12.0591 11.2101 12.0591 10.9758 11.8247L8.36579 9.21471C8.13147 8.98039 8.13147 8.60049 8.36579 8.36617Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c7a6667cadd5be3a8ce29b6a477727c8.svg";
export { ForwardRef as ReactComponent };